// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProgressBar_wrapper__3phmv","progress":"ProgressBar_progress__1hLOL"};